import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoahmedabadcab() {



  const cardData =
  {
    keyword: 'Mumbai to Ahmedabad Cab ',
    heading: 'Shambhu Cabs: Mumbai to Ahmedabad Cab ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Ahmedabad Cab services, providing safe, comfortable, and hassle-free travel for families, business travelers, corporate groups, and long-distance commuters heading to Ahmedabad. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and relaxing journey from Mumbai to Ahmedabad with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes your intercity travel convenient and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs offers doorstep pickup and trusted Mumbai to Ahmedabad cab services for travelers seeking comfort, safety, punctuality, and a dependable long-distance travel experience.',

    top: 'Top Places to Visit in Ahmedabad with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, also known as Gandhi Ashram, is one of the most historically significant places in India. Located on the serene banks of the Sabarmati River, this was Mahatma Gandhi’s residence and the epicenter of several major events of India's freedom struggle. It was from here that the iconic Dandi March (Salt Satyagraha) was launched in 1930. Visitors can explore Gandhi’s living quarters, the Hriday Kunj, a museum showcasing letters, photographs, personal belongings, and detailed exhibits about his philosophy of non-violence (Ahimsa) and truth (Satya). The peaceful ambience, meditation spots, and the well-maintained surroundings make the ashram a place of deep reflection and learning for all age groups."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is one of the largest and most vibrant recreational hubs in Ahmedabad, known for its scenic beauty, attractions, and family-friendly activities. Built during the 15th century by Sultan Qutb-ud-din, the lake features an island garden in the center known as Nagina Wadi. The area around the lake is developed into a complete entertainment zone with a zoo, toy train, balloon rides, water activities, cycling tracks, food courts, and evening laser shows. The annual Kankaria Carnival is a major cultural event showcasing art, performances, food stalls, and exhibitions. It is one of the best places in the city for leisure, photography, and nightlife experiences."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid in Ahmedabad is a grand 15th-century mosque built by Sultan Ahmed Shah, the founder of the city. Known for its Indo-Islamic architectural brilliance, the mosque features yellow sandstone pillars, intricately carved designs, domes, and a vast courtyard. The beauty of Jama Masjid lies in its fusion of Hindu, Jain, and Islamic architectural styles — a hallmark of Gujarat’s heritage. The mosque originally served as the private place of worship for the royal family. The calm surroundings, beautifully patterned floors, arched corridors, and symmetrical stonework make it a masterpiece of ancient craftsmanship and a must-visit heritage landmark."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, also known as Adalaj ni Vav, is an exquisite five-story stepwell located near Ahmedabad, built in 1498 by Queen Rudabai. It is considered one of the finest examples of ancient Gujarati architecture. The stepwell was constructed to provide water, shelter, and a place for travelers and villagers to rest during hot summers. The beautifully carved walls depict mythological figures, floral motifs, deities, and intricate geometric patterns. The natural cooling effect of the underground structure creates a soothing environment. The stepwell also reflects the region’s historical blend of Hindu and Islamic artistic styles. It is a popular spot for history lovers, architects, and photographers."
  },
  {
    "title": "Science City",
    "description": "Gujarat Science City is a massive, modern educational and entertainment complex that showcases the wonders of science through interactive exhibits and engaging experiences. The campus includes a 3D IMAX theater, robotics gallery, life science park, energy park, and numerous hands-on science experiments suitable for all age groups. The Aquatic Gallery, one of the highlights, features India’s largest public aquarium with exotic marine species. The Mission to Mars and Space Zone provide immersive learning about astronomy and space exploration. The lush surroundings, learning-based attractions, and well-organized exhibits make Science City one of the most exciting family destinations in Ahmedabad."
  }
],




"services": [
  {
    "name": "Mumbai Ahmedabad Taxi",
    "description": "Mumbai Ahmedabad Taxi offers dependable, comfortable, and long-distance intercity travel between Mumbai and Ahmedabad. With expert chauffeurs, well-maintained vehicles, and seamless highway connectivity, this service is ideal for business travelers, families, tourists, and corporate executives. The journey ensures smooth expressway travel, flexible pickup options, transparent fares, and a hassle-free door-to-door ride experience."
  },
  {
    "name": "One-Way Cab Mumbai Ahmedabad",
    "description": "One-Way Cab Mumbai Ahmedabad provides economical one-direction travel for passengers heading from Mumbai to Ahmedabad without needing a return cab. This service includes sedans, SUVs, and premium cars driven by skilled chauffeurs who specialize in long-route driving. Perfect for relocations, office transfers, hotel check-ins, events, medical travel, and emergency journeys with zero round-trip charges."
  },
  {
    "name": "Affordable Ahmedabad Cab Mumbai",
    "description": "Affordable Ahmedabad Cab Mumbai delivers budget-friendly long-distance taxi services for travelers seeking economical options. Despite low prices, the service ensures clean cars, experienced drivers, safe route planning, and smooth travel. It is ideal for students, families, and frequent commuters who want reliable transportation at competitive fares."
  },
  {
    "name": "Best Taxi Mumbai Ahmedabad",
    "description": "Best Taxi Mumbai Ahmedabad ensures a premium quality travel experience with superior comfort, highly professional drivers, and on-time pickup. This service is ideal for travelers who prioritize luxury, convenience, and reliability for long-distance travel. Smooth expressway driving, sanitized interiors, and top-tier customer service make it a preferred choice."
  },
  {
    "name": "SUV Cab Mumbai Ahmedabad",
    "description": "SUV Cab Mumbai Ahmedabad offers spacious and powerful SUVs for long-distance comfort, ideal for group travel, family journeys, and passengers with extra luggage. The SUVs provide enhanced legroom, smoother suspension, and a comfortable ride over long hours, making the trip pleasant and stress-free."
  },
  {
    "name": "Sedan Cab Mumbai Ahmedabad",
    "description": "Sedan Cab Mumbai Ahmedabad is perfect for those seeking a fuel-efficient, comfortable, and pocket-friendly travel option. Sedans offer smooth performance, air-conditioned interiors, and superior ride quality, making them suitable for business travelers, couples, and solo passengers looking for an affordable yet premium ride."
  },
  {
    "name": "24×7 Mumbai Ahmedabad Taxi",
    "description": "24×7 Mumbai Ahmedabad Taxi provides round-the-clock cab availability for early-morning departures, late-night emergencies, business trips, and planned travel. With instant booking options, prompt pickups, and reliable drivers, this service guarantees convenient and safe travel at any time of the day or night."
  },
  {
    "name": "Corporate Cab Mumbai Ahmedabad",
    "description": "Corporate Cab Mumbai Ahmedabad caters to business travelers and companies requiring professional transportation between the two cities. With high-standard vehicles, punctual chauffeurs, and corporate-grade service quality, it ensures comfortable executive travel for meetings, conferences, and business visits."
  },
  {
    "name": "Fast Cab Mumbai Ahmedabad",
    "description": "Fast Cab Mumbai Ahmedabad focuses on the quickest travel with efficient expressway driving, minimal stoppages, and experienced drivers who know the route well. Ideal for urgent trips, business emergencies, and same-day travel between Mumbai and Ahmedabad, this service combines speed with complete safety."
  },
  {
    "name": "Outstation Cab Mumbai Ahmedabad",
    "description": "Outstation Cab Mumbai Ahmedabad provides dependable intercity travel with options including one-way trips, round trips, and multi-day rentals. This service is suitable for tourists, business travelers, and families, offering comfortable vehicles, long-route-trained drivers, and flexible itinerary support."
  },
  {
    "name": "Family Cab Mumbai Ahmedabad",
    "description": "Family Cab Mumbai Ahmedabad ensures safe, comfortable, and family-friendly travel with spacious vehicles, child-friendly seating, extra luggage space, and courteous drivers. It is ideal for holidays, family functions, medical travel, vacation tours, and group journeys to Ahmedabad."
  },
  {
    "name": "Premium Cab Ahmedabad Trip",
    "description": "Premium Cab Ahmedabad Trip offers luxury sedans and SUVs with plush interiors, powerful AC, and a smooth ride experience for travelers seeking comfort and elegance. Perfect for VIP guests, corporate executives, special events, and travelers who prefer a high-end long-distance journey."
  },
  {
    "name": "Safe Taxi Mumbai Ahmedabad",
    "description": "Safe Taxi Mumbai Ahmedabad prioritizes passenger security with trained and verified chauffeurs, sanitized vehicles, GPS tracking, and safety-focused driving practices. This service is ideal for senior citizens, women travelers, families, and solo passengers who need a trustworthy intercity travel solution."
  },
  {
    "name": "Mumbai Ahmedabad Pickup Drop",
    "description": "Mumbai Ahmedabad Pickup Drop provides point-to-point transfers from any location in Mumbai—including homes, airports, hotels, and offices—to any destination in Ahmedabad. The service offers flexible timings, smooth travel coordination, and reliable transfers suitable for all travel needs."
  },
  {
    "name": "Highway Cab Mumbai Ahmedabad",
    "description": "Highway Cab Mumbai Ahmedabad specializes in fast and safe expressway travel with drivers trained for long-distance highway routes. Ideal for passengers seeking a smooth, uninterrupted drive with great comfort and speed, this service ensures efficient navigation of major national highways."
  },
  {
    "name": "Long Distance Cab Mumbai Ahmedabad",
    "description": "Long Distance Cab Mumbai Ahmedabad is designed specifically for extended journeys with comfortable seating, spacious vehicles, and professional drivers skilled in long-duration driving. Suitable for leisure, corporate, and relocation travel, it guarantees a stress-free, relaxing long-route experience."
  },
  {
    "name": "Mumbai Gandhinagar Cab",
    "description": "Mumbai Gandhinagar Cab offers direct travel from Mumbai to the capital city of Gujarat with reliable drivers and well-maintained cars. Ideal for government visits, business trips, and family travel, this service ensures smooth, comfortable, and timely travel all the way to Gandhinagar."
  }
],

"tableData": [
  ["Mumbai Ahmedabad Taxi", "One-Way Cab Mumbai Ahmedabad"],
  ["Affordable Ahmedabad Cab Mumbai", "Best Taxi Mumbai Ahmedabad"],
  ["SUV Cab Mumbai Ahmedabad", "Sedan Cab Mumbai Ahmedabad"],
  ["24×7 Mumbai Ahmedabad Taxi", "Corporate Cab Mumbai Ahmedabad"],
  ["Fast Cab Mumbai Ahmedabad", "Outstation Cab Mumbai Ahmedabad"],
  ["Family Cab Mumbai Ahmedabad", "Premium Cab Ahmedabad Trip"],
  ["Safe Taxi Mumbai Ahmedabad", "Mumbai Ahmedabad Pickup Drop"],
  ["Highway Cab Mumbai Ahmedabad", "Long Distance Cab Mumbai Ahmedabad"],
  ["Mumbai Gandhinagar Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Ahmedabad Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Ahmedabad cab services, ideal for business trips, family travel, and long-distance intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to ensure a smooth and comfortable journey to Ahmedabad."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long Highway Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai to Ahmedabad highway route, ensuring safe, timely, and stress-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Ahmedabad cab booking hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to help with bookings, travel queries, and route assistance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Intercity Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable rental packages tailored to your Mumbai to Ahmedabad travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Ahmedabad journey comfortable and worry-free."
  }
]


























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Ahmedabad cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Ahmedabad cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Ahmedabad cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick and hassle-free booking.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Ahmedabad cab bookings?',
    answer: 'Shambhu Cabs offers a wide fleet of well-maintained sedans, SUVs, and luxury cars suitable for long-distance travel from Mumbai to Ahmedabad.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Ahmedabad route?',
    answer: 'Yes, our drivers are licensed, trained, and familiar with the Mumbai to Ahmedabad highway route to ensure a safe and smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Ahmedabad cab?',
    answer: 'Absolutely. You can select any preferred pickup point in Mumbai and choose a drop-off location anywhere in Ahmedabad.',
  },
  {
    question: 'Is the Mumbai to Ahmedabad cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Ahmedabad cab booking services to suit your travel plans.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Ahmedabad cab bookings?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols for passenger comfort and well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Ahmedabad cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate invoice payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Ahmedabad journey?',
    answer: 'Yes, our 24x7 customer support team is available at all times to assist you throughout your Mumbai to Ahmedabad travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harsh Vyas',
    feedback: 'Our Mumbai to Ahmedabad journey with Shambhu Cabs was smooth and comfortable. Excellent driver and a well-maintained car.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Shah',
    feedback: 'Shambhu Cabs provided a reliable Mumbai to Ahmedabad cab service. Clean vehicle, polite driver, and timely pickup!',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ahmedabad Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-ahmedabad-cab.jpg",
  "description": "Shambhu Cabs provides safe and reliable Mumbai to Ahmedabad cab services for one-way and round trips. Book sedans, SUVs, or premium cars for family trips, corporate travel, and long-distance journeys. Enjoy affordable, fast, and 24×7 taxi service with professional drivers, highway trips, and pickup-drop options to Gandhinagar.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-ahmedabad-cab"
  }
};








  return (
    <div>
<Helmet>
  <title>Mumbai to Ahmedabad Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Ahmedabad cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for one-way and round trips, family travel, corporate travel, and long-distance journeys. Available 24×7 with sedan, SUV, and premium cars, including pickup-drop to Gandhinagar."
  />

  <meta
    name="keywords"
    content="Mumbai Ahmedabad Taxi, One-Way Cab Mumbai Ahmedabad, Affordable Ahmedabad Cab Mumbai, Best Taxi Mumbai Ahmedabad, SUV Cab Mumbai Ahmedabad, Sedan Cab Mumbai Ahmedabad, 24×7 Mumbai Ahmedabad Taxi, Corporate Cab Mumbai Ahmedabad, Fast Cab Mumbai Ahmedabad, Outstation Cab Mumbai Ahmedabad, Family Cab Mumbai Ahmedabad, Premium Cab Ahmedabad Trip, Safe Taxi Mumbai Ahmedabad, Mumbai Ahmedabad Pickup Drop, Highway Cab Mumbai Ahmedabad, Long Distance Cab Mumbai Ahmedabad, Mumbai Gandhinagar Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoahmedabadcab;